import { useState } from "react";
import { Alert, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import RegionForm from "../../../../components/forms/configuration/RegionForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback } from "react";
import RegionService from "../../../../services/region.service";
import { useEffect } from "react";
import BodyService from "../../../../services/body.service";
import UserPermissionService from "../../../../services/userPermission.service";

const RegionDetails = () => {
    const params = useParams();
    
    const navigate = useNavigate();

    const { t } = useTranslation();

    const [region, setRegion] = useState();

    const [translations, setTranslations] = useState([]);

    const [title, setTitle] = useState("");

    const [permissions, setPermissions] = useState({});
    
    const [success, setSuccess] = useState({
        update: false,
        email: false,
    });

    const [errors, setErrors] = useState({
        update: false,
    });

    const getRegion = useCallback(async (id) => {
        try {
            const data = await RegionService.getById(id);           
            setRegion(data);            
            setTitle(data.name["es"].value);            
        } catch (error) {
            navigate("/configuration/region");
        }

    }, [navigate])

    const updateRegion = async (data) => {
        setErrors({ ...errors, update: false });
        setSuccess({ ...success, update: false });

        try {
            await RegionService.update(params.id, data);
            getRegion(params.id);
            setSuccess({ ...success, update: true });
        } catch (e) {
            setErrors({ ...errors, update: true });
        }
    }

    const getEmptyTranslations = async () => {
        const data = await BodyService.getEmptyTranslations();
        setTranslations(data);
    };

    const getPermissions = async () => {
        try {
            const data = await UserPermissionService.getPermissionsByConnected();
            setPermissions(data);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        const loadData = async () => {
            await getPermissions();
        }

        loadData();
    }, []);

    useEffect(()=>{
        getRegion(params.id);
        getEmptyTranslations();
    },[getRegion,params.id]);

    return (
        <>
            <Alert variant={"success"} show={success.update} dismissible onClose={() => setSuccess({ ...success, update: false })}>
                {t('region.success.update')}
            </Alert>

            <Alert variant={"danger"} show={errors.update} dismissible onClose={() => setErrors({ ...errors, update: false })}>
                {t('region.error.update')}
            </Alert>

            <div className={"d-flex justify-content-between my-3"}>
                <Link to="/configuration/region" className={"previous round rounded-circle text-decoration-none"}
                    title={t('general.back')}>
                    <FontAwesomeIcon icon={"chevron-left"} className={"mt-2 me-2"} />
                    <span>{t('region.title')}</span>
                </Link>
            </div>
            <Card>
                <Card.Header className={"py-3"}>
                    <h1 className={"h3 mb-0 text-gray-800 card-title text-capitalize"}>{title}</h1>
                </Card.Header>
                <Card.Body>
                    <RegionForm onSubmit={updateRegion} region={region} translations={translations} permissions={permissions} details />
                </Card.Body>
            </Card>
        </>);
}

export default RegionDetails;